import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden pt-12 pb-16 md:pt-20 md:pb-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-33">
      <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-34">
        {/* Text Content */}
        <div className="flex-1 text-center lg:text-left z-10" data-id="element-35">
          <div className="inline-block px-4 py-1.5 mb-6 rounded-full bg-[#F3EFE7] text-[#4A2C40] text-sm font-semibold tracking-wide uppercase" data-id="element-36">
            For the days you feel like quitting
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[#4A2C40] leading-[1.1] mb-6" data-id="element-37">
            Stop Losing the Same Week Every Month
          </h1>

          <p className="text-xl md:text-2xl text-[#4A2C40]/80 mb-8 font-light leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-38">
            The Luteal Survival Kit: A plan you can actually follow when you're
            tired, emotional, and ready to give up.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-39">
            <Button size="lg" className="shadow-lg shadow-[#4A2C40]/10" onClick={() => document.getElementById('pricing-cta')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-40">
              Get The Survival Kit
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-41" />
            </Button>
            <Button variant="ghost" size="lg" onClick={() => document.getElementById('pricing-cta')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-42">
              Read the full story
            </Button>
          </div>

          <p className="mt-6 text-sm text-[#4A2C40]/60 italic" data-id="element-43">
            Instant PDF download • 10-Minute Rescue Protocol included
          </p>
        </div>

        {/* Image */}
        <div className="flex-1 w-full max-w-lg lg:max-w-xl relative" data-id="element-44">
          <div className="absolute -inset-4 bg-[#F3EFE7] rounded-full blur-3xl opacity-50 -z-10" data-id="element-45"></div>
          <img src="https://cdn.magicpatterns.com/uploads/86hCigRaZoHxCDafLnV7FF/Survival.png" alt="The Luteal Survival Kit on a tablet" className="w-full h-auto rounded-2xl shadow-2xl shadow-[#4A2C40]/20 transform hover:scale-[1.02] transition-transform duration-500" data-id="element-46" />
        </div>
      </div>
    </section>;
}